import BaseCard from './BaseCard';
import { CardType } from './CardType';
import GameObject from '../../../GameObject/GameObject';
import Container from '../../Container';
import { ICardModifierData } from './ICardModifierData';
import { ModifierTypeMap } from './CardData';
import Gold from './Gold';

enum GoldSuit {
    CLUB = 'club',
    DIAMOND = 'diamond',
    HEART = 'heart',
    SPADES = 'spades',
}

export default class GoldCard extends BaseCard {
    public isBlocked: boolean = true;

    protected onCreate(params: any): void {
        switch (params.suit) {
            case 0:
                params.cardFrontTexture = GoldSuit.CLUB;
                break;
            case 1:
                params.cardFrontTexture = GoldSuit.HEART;
                break;
            case 2:
                params.cardFrontTexture = GoldSuit.SPADES;
                break;
            case 3:
                params.cardFrontTexture = GoldSuit.DIAMOND;
                break;
        }
        params.type = CardType.gold;
        super.onCreate(params);

        // Create modifier container.
        const modifierContainer = GameObject.Instantiate(Container, {
            name: 'modifierContainer',
            visible: params.faceUp,
        });

        // Add any modifiers.
        params.modifiers &&
            params.modifiers.forEach((modifierParams: ICardModifierData) => {
                params = {
                    ...modifierParams,
                    properties: {
                        ...modifierParams.properties,
                    },
                    name: modifierParams.type.toString(), // Set gameobject name to type for later lookup.
                };

                modifierContainer.addChild(
                    GameObject.Instantiate(
                        ModifierTypeMap[modifierParams.type].prototype,
                        params
                    )
                );
            });
        const animationContainer = GameObject.Instantiate(Container, {
            name: 'animationContainer',
            visible: params.faceUp,
        });
        animationContainer.addChild(GameObject.Instantiate(Gold));
        this.addChild(animationContainer);
        this.addChild(modifierContainer);
    }
}